import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { LOADING_TEXT, PAGE_TITLE } from './constants'
import pages from 'containers/Pages/pages'

const AdminSubPages = props => {
  const {
    entry,
    isContentChangingEntries,
    isFetching,
    isLoadingApp,
    setAppIsLoadingState,
    setAppNotLoadingState,
  } = props
  const { displayTitle } = entry || {}
  const contentType = entry?.contentType?.id
  const Page = pages[contentType]
  const readyToLoad = isFetching || isContentChangingEntries || !entry

  const shouldUpdateLoadingState = () => {
    if (readyToLoad && !isLoadingApp) {
      setAppIsLoadingState(LOADING_TEXT)
    }
    if (!readyToLoad && isLoadingApp) {
      setAppNotLoadingState()
    }
  }

  const tabTitles = {
    page: PAGE_TITLE,
    tab: displayTitle,
  }

  useEffect(() => {
    shouldUpdateLoadingState()
    return () => {
      if (isLoadingApp) {
        setAppNotLoadingState()
      }
    }
  }, [readyToLoad])

  useEffect(() => {
    if (displayTitle) {
      document.title = `${tabTitles.page} | ${tabTitles.tab}`
    }
  }, [displayTitle])

  const adminProps = { ...props, isDistrict: true }
  return Page ? <Page {...adminProps} /> : null
}

AdminSubPages.propTypes = {
  entry: PropTypes.object,
  isContentChangingEntries: PropTypes.bool,
  isFetching: PropTypes.bool,
  isLoadingApp: PropTypes.bool,
  setAppIsLoadingState: PropTypes.func,
  setAppNotLoadingState: PropTypes.func,
}

export default AdminSubPages
